import { render, staticRenderFns } from "./DayaDukungView.vue?vue&type=template&id=48b12b7c&scoped=true"
import script from "./DayaDukungView.vue?vue&type=script&lang=js"
export * from "./DayaDukungView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b12b7c",
  null
  
)

export default component.exports